export default __webpack_public_path__ + "static/media/Zasway-Logo-PassengerApp.3fc445e9.png";